/**
 * SummaryTiles.tsx — four count tiles (GREEN / AMBER / RED / GREY).
 */

import React, { useMemo } from 'react';

import type { BankSubmissionRow, Flag } from '../../type/api';
import { flagLabel } from '../../helpers/flag';

interface Props {
	rows: BankSubmissionRow[];
}

const FLAGS: Flag[] = ['GREEN', 'AMBER', 'RED', 'GREY'];

const FLAG_BLURB: Record<Flag, string> = {
	GREEN: 'Submitted in last 24h',
	AMBER: 'Stale 1–7 days',
	RED: 'Overdue · > 7 days',
	GREY: 'Never submitted',
};

export default function SummaryTiles({ rows }: Props) {
	const counts = useMemo(() => {
		const c: Record<Flag, number> = { GREEN: 0, AMBER: 0, RED: 0, GREY: 0 };
		for (const r of rows) c[r.overallFlag] += 1;
		return c;
	}, [rows]);

	return (
		<div className="grid cols-4">
			{FLAGS.map((f) => (
				<div key={f} className={`summary-tile ${f.toLowerCase()}`}>
					<div className="strip" aria-hidden="true" />
					<div className="lbl">{flagLabel(f)}</div>
					<div className="val">{counts[f]}</div>
					<div className="sub">{FLAG_BLURB[f]}</div>
				</div>
			))}
		</div>
	);
}
